GP.collections.Premium = Backbone.Collection.extend({
    model: GP.models.Premium,
    initialize: function(data) {

    }
});